import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: "ionicon",
	viewBox: "48 48 416 416",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-32 272a16 16 0 01-32 0V192a16 16 0 0132 0zm96 0a16 16 0 01-32 0V192a16 16 0 0132 0z" })
});
export default SvgPauseCircle;
